export const localStorageObjects = {
  DPrimeAddedWallet: 'DPrimeAddedWallet',
  agreedTcByWallet: 'agreedTcByWallet',
  pendingTxs: 'pendingTxs',
  historyTxs: 'historyTxs',
  disconnected: 'disconnected'
}
